module.exports = __webpack_public_path__ + "static/media/bannerIconTrans.7c6383cb.svg";